import React from "react";
import { useDispatch } from "react-redux";
import Canvas from "../../../components/Canvas";
import { setModalLoading } from "../../../actions/loading";

const HeroSection = () => {
  const dispatch = useDispatch();

  const handleBookInterview = () => {
    dispatch(setModalLoading(true));
  };

  return (
    <section className="page-hero">
      <Canvas />
      <div className="container page-hero-grid">
        <div>
          <p className="eyebrow">Who We Are / About Us - Lovapex</p>
          <h1>We Don't Just Help You Apply. We Help You Get Hired.</h1>
          <p className="hero-copy">
            Lovapex Tech turns job-search chaos into a managed process with
            career strategy, recruiter outreach, resume positioning, and weekly
            execution.
          </p>
          <div className="actions">
            <button
              className="button button-primary button-md"
              onClick={() => handleBookInterview()}
            >
              Book a Free Strategic Consultation
            </button>
          </div>
        </div>
        <div className="page-hero-media">
          <div
            className="section-image about-hero-image"
            aria-label="Lovapex team planning a managed job search"
          ></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
